class LoadingContainerService {
	// We know it's in the dom from index.html
	private loadingContainer: HTMLElement | null = document.getElementById(
		'LoadingContainer',
	) as HTMLElement

	public readonly show = () => {
		if (this.loadingContainer) {
			this.loadingContainer.style.display = 'flex'
		}
	}

	public readonly hide = () => {
		if (this.loadingContainer) {
			this.loadingContainer.style.display = 'none'
		}
	}
}

export const loadingContainerService = new LoadingContainerService()
